<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>推荐数设置</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="width: 360px !important; margin-right: 20px">
          <el-select
            v-model="queryInfo.MatchID"
            placeholder="请选择赛项名称"
            style="width: 360px !important"
          >
            <el-option
              v-for="item in matchNameoptions"
              :key="item.MatchID"
              :label="item.MatchName"
              :value="item.MatchID"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" style="margin-right:30px;">
          <el-select
            v-model="queryInfo.SchoolID"
            filterable
            placeholder="请选择学校"
            @change="handlerSelect"
            style="width:240px !important;"
          >
            <el-option
              v-for="item in AffiliatedUnitOptions"
              :key="item.SchoolID"
              :label="item.SchoolName"
              :value="item.SchoolID"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button
            icon="el-icon-search"
            type="primary"
            @click="getSettrackList(1)"
            >搜索</el-button
          >
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称" width="280">
        </el-table-column>
        <el-table-column prop="TrackName" label="赛道名称"> </el-table-column>
        <el-table-column prop="RecEntriesNum" label="可推荐作品数">
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showEditSettrack(scope.row)"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 修改 -->
      <el-dialog
        title="修改可推荐作品数"
        :visible.sync="editDialogVisible"
        width="30%"
      >
        <el-form
          :model="editForm"
          :rules="editRules"
          ref="editFormRef"
          label-width="100px"
        >
          <el-form-item label="赛事名称">
            <el-input v-model="editForm.MatchName" disabled></el-input>
          </el-form-item>
          <el-form-item label="赛道名称">
            <el-input v-model="editForm.TrackName" disabled></el-input>
          </el-form-item>
          <el-form-item label="学校名称">
            <el-select
              v-model="editForm.SchoolID"
              filterable
              placeholder="请选择学校"
              @change="handlerSelect"
              disabled
            >
              <el-option
                v-for="item in AffiliatedUnitOptions"
                :key="item.SchoolID"
                :label="item.SchoolName"
                :value="item.SchoolID"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可推荐作品数">
            <el-input-number
              style="width: 40%"
              v-model="editForm.RecEntriesNum"
              :min="1"
              controls-position="right"
              placeholder="请输入可推荐作品数"
            ></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editSettrack()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        MatchID: '',
        SchoolID: ''
      },
      pagedata: [],
      // 修改弹框显示状态
      editDialogVisible: false,
      // 学校下拉
      AffiliatedUnitOptions: [
        {
          value: '1',
          label: '北京大学'
        },
        {
          value: '2',
          label: '上海大学'
        }
      ],
      // 修改表单
      editForm: {},
      // 修改表单验证
      editRules: {
        MatchID: [
          {
            required: true,
            message: '请选择赛事名称',
            trigger: 'change'
          }
        ],
        TrackName: [
          {
            required: true,
            message: '请输入赛道名称',
            trigger: 'blur'
          }
        ],
        TrackNumber: [
          {
            required: true,
            message: '请输入赛道号',
            trigger: 'blur'
          }
        ]
      },
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ]
    }
  },
  created() {
    this.getAllMatch()
    this.getBelongs()
  },
  methods: {
    //   获取学校设置列表
    async getSettrackList() {
      const { data: res } = await this.$http.post(
        '/api/SchoolSetting/SchoolSettingList',
        this.queryInfo
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
      this.queryInfo.MatchID = this.matchNameoptions[0].MatchID
    },
    // 获取学校
    async getBelongs() {
      const { data: res } = await this.$http.get('/api/School/GetAllSchoolName')
      this.AffiliatedUnitOptions = res.Data.schools
      this.queryInfo.SchoolID = this.AffiliatedUnitOptions[0].SchoolID
      //   默认获取列表
      this.getSettrackList()
    },
    // 获取学校下拉当前选中的label值（学校名）
    handlerSelect(val) {
      if (val) {
        let obj = {}
        obj = this.AffiliatedUnitOptions.find((item) => {
          return item.SchoolID === val
        })
        this.editForm.AffiliatedUnit = obj.SchoolName
      }
    },

    // 显示修改赛事弹窗
    showEditSettrack(row) {
      this.editForm = row
      this.editForm.SchoolID = this.queryInfo.SchoolID
      this.editDialogVisible = true
    },
    // 修改
    editSettrack() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/SchoolSetting/EditSchoolSetting',
          this.editForm
        )
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getSettrackList()
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
